import HTTP from './http'
import { AxiosResponse } from 'axios'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER, REQUEST_RETRIES_DOUBLE } from './constants'
import { IHTTPVerbsData } from './interface'

// REQUEST REPORT POST  .........................................................................................
export const requestReportPost = ({
  data,
  id,
  params,
  testMode,
  version = '1'
}: IHTTPVerbsData): Promise<AxiosResponse> => {
  const query_params = new URLSearchParams(params || '').toString()

  return HTTP.panel.post(`/v${version}/reports?${query_params}`, JSON.stringify(data), {
    headers: {
      ...HEADER.apiVersion(version === '1' ? '1.0.0' : '2.0.0'),
      ...HEADER.activityPermission.getFromValue('reports:write'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json,
      ...HEADER.liveMode.getFromTestMode(testMode)
    }
  })
}

// REPORT LIST GET ..............................................................................................
export const listReportsGet = ({ sessionId, testMode, version = '1' }: IHTTPVerbsData): Promise<AxiosResponse> => {
  return HTTP.panel.get(`/v${version}/reports/${sessionId}`, {
    'axios-retry': {
      retries: REQUEST_RETRIES_DOUBLE
    },
    headers: {
      ...HEADER.apiVersion(version === '1' ? '1.0.0' : '2.0.0'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromLocalStorage(),
      ...HEADER.json,
      ...HEADER.liveMode.getFromTestMode(testMode)
    }
  })
}


export const customInvoiceReportGet = ({params}:Required<Pick<IHTTPVerbsData,  'params' >> ):Promise<AxiosResponse> =>
  HTTP.panel.get(`/v1/reports/custom-invoicing`, {
    params,
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })
